/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");
var xtend = require("xtend");

var REPEAT_INTERVAL = 2 * 60 * 1000;
var REPEAT_STOP_OFFSET = 1 * 60 * 1000;

module.exports = Model({
	name: "activereminder",
	init: init,
	listeners: listeners,
	triggers: triggers,

	clearNotificationTimers: clearNotificationTimers,
	repeatNotification: repeatNotification,
	setActive: setActive,
	recalculate: recalculate,

	_reminders: null,
	_history: null,
	_notificationRepeater: null,
	_notificationRepeatStopper: null,
});

function listeners() {
	return {
		"reminders:updated": Model.makeRecalculator("reminders"),
		"remindershistory:updated": Model.makeRecalculator("history")
	};
}

function triggers(){
	return {
		"respond": reminderRespond
	};
}

function init() {
	this._reminders = [];
	this._history = [];
	this.push(null);
}

function recalculate(){
	var reminders = this._reminders;
	var history = this._history;
	var currentActive = this.data;
	if(!history.length || !reminders.length){
		this.dispatch("hidden");
		this.clearNotificationTimers();
		if(currentActive){
			this.push(null);
			this.emit("pausescreen:trigger:pause");
		}
		return;
	}

	var active = xtend(findReminder(reminders, history[0].reminder), {
		history: history[0]
	});

	if(currentActive && historyExists(currentActive.history, history))
		return;

	if(active){
		this.setActive(active);
	}
}

function setActive(reminder){
	this.push(reminder);

	if(reminder.notification === -1) return;

	this.dispatch("active", reminder);

	if(reminder.notification > 0)
		this.repeatNotification(reminder);
}

function reminderRespond(data) {
	var action = data.action;
	var reminder = this.data;
	var response = data.response;
	if(!reminder) return;

	var history = reminder.history;
	var historyId = history._id;
	if (action === "accept")
		this.api.reminders.history.accept(historyId);
	if (action === "deny")
		this.api.reminders.history.deny(historyId);
	if (action === "respond") {
		this.api.reminders.history.respond(historyId, response);
	}
	this.emit("usermetrics:trigger:track", "respond to own reminder", {
		reminder: reminder._id,
	});
}

function clearNotificationTimers() {
	if (this._notificationRepeater) {
		clearInterval(this._notificationRepeater);
		this._notificationRepeater = null;
	}
	if (this._notificationRepeatStopper) {
		clearTimeout(this._notificationRepeatStopper);
		this._notificationRepeatStopper = null;
	}
}

function findReminder(list, reminderId){
	return list.reduce(function(result, reminder){
		if(reminder._id === reminderId)
			return result = reminder;
		return result;
	}, {});
}

function repeatNotification(reminder) {
	this.clearNotificationTimers();
	this._notificationRepeater = setInterval(this.dispatch.bind(this, "active", reminder), REPEAT_INTERVAL);
	this._notificationRepeatStopper = setTimeout(stopRepeatingNotification.bind(this), (reminder.notification * REPEAT_STOP_OFFSET) + 100);
}

function stopRepeatingNotification() {
	this.clearNotificationTimers();
}

function historyExists(item, list){
	return list.reduce(function(result, history){
		if(item._id === history._id) return result = true;
		return result;
	}, false);
}